shadow$provide[325] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Buffer:{enumerable:true, get:function() {
  return Buffer;
}}});
var UData = require("../../util/data.js");
var require$_DOT__DOT__SLASH_renderable_DOT_js = require("../renderable.js");
class Buffer extends require$_DOT__DOT__SLASH_renderable_DOT_js.Renderable {
  constructor(renderer, shaders, options) {
    super(renderer, shaders);
    if (this.items == null) {
      this.items = options.items || 1;
    }
    if (this.samples == null) {
      this.samples = options.samples || 1;
    }
    if (this.channels == null) {
      this.channels = options.channels || 4;
    }
    if (this.callback == null) {
      this.callback = options.callback || function() {
      };
    }
  }
  dispose() {
    return super.dispose();
  }
  update() {
    const n = this.fill();
    this.write(n);
    return n;
  }
  setActive(_i, _j, _k, _l) {
  }
  setCallback(callback) {
    this.callback = callback;
  }
  write() {
  }
  fill() {
  }
  generate(data) {
    return UData.getStreamer(data, this.samples, this.channels, this.items);
  }
}

};